"use strict";

var _interopRequireDefault = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setUserInfo = exports.default = void 0;

require("regenerator-runtime/runtime.js");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.json.stringify.js");

require("core-js/modules/es.string.starts-with.js");

var _common = require("@/api/common");

var _user = require("@/api/user");

var _auth = require("@/utils/auth");

var _utils = require("@/utils");

var state = {
  token: (0, _auth.getToken)(),
  name: '',
  avatar: '',
  developer_uid: '',
  group_id: '',
  roles: [],
  userInfo: null,
  getVipStatus: false,
  vipLevel: 0,
  isVip: false,
  performanceCount: 0,
  email: '',
  // 第一次加载菜单时用到
  loadMenus: false,
  isSdkInit: false
};
var mutations = {
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
  },
  SET_AVATAR: function SET_AVATAR(state, avatar) {
    state.avatar = avatar;
  },
  SET_DEVELOPERUID: function SET_DEVELOPERUID(state, developer_uid) {
    state.developer_uid = developer_uid;
  },
  SET_GROUPID: function SET_GROUPID(state, group_id) {
    state.group_id = group_id;
  },
  SET_ROLES: function SET_ROLES(state, roles) {
    state.roles = roles;
  },
  SET_LOAD_MENUS: function SET_LOAD_MENUS(state, loadMenus) {
    state.loadMenus = loadMenus;
  },
  SET_USERINFO: function SET_USERINFO(state, userInfo) {
    state.userInfo = userInfo;
  },
  SET_VIP_STATUS: function SET_VIP_STATUS(state, getVipStatus) {
    state.getVipStatus = getVipStatus;
  },
  SET_VIP_LEVEL: function SET_VIP_LEVEL(state, vipLevel) {
    state.vipLevel = vipLevel;
  },
  SET_IS_VIP: function SET_IS_VIP(state, isVip) {
    state.isVip = isVip;
  },
  SET_PERFORMANCE_COUNT: function SET_PERFORMANCE_COUNT(state, performanceCount) {
    state.performanceCount = performanceCount;
  },
  SET_EMAIL: function SET_EMAIL(state, email) {
    state.email = email;
  },
  SET_IS_SDK_INIT: function SET_IS_SDK_INIT(state, isSdkInit) {
    state.isSdkInit = isSdkInit;
  }
};
var actions = {
  // user login
  login: function login(_ref, userInfo) {
    var commit = _ref.commit,
        state = _ref.state;
    // const { username, password, loginType } = userInfo
    return new Promise(function (resolve, reject) {
      // { username: username.trim(), password: password, loginType: loginType }
      if (state.isSdkInit) {
        LAYA_UNIFY_SDK && LAYA_UNIFY_SDK.login({
          'loginUrl': ''
        }, function (data) {
          console.log(data, '登录返回值');
          localStorage.setItem((0, _utils.getStorageKey)('loginSDK'), JSON.stringify(data));
          userInfo.code = data.token;
          (0, _common.login)(userInfo).then(function (response) {
            var data = response.data.data;

            if (!data) {
              reject('验证失败，请重新登录。');
            }

            var nickname = data.nickname,
                avatar = data.avatar,
                developer_uid = data.developer_uid,
                group_id = data.group_id,
                token = data.token,
                email = data.email;
            commit('SET_TOKEN', token);
            (0, _auth.setToken)(token);
            commit('SET_NAME', nickname);
            commit('SET_AVATAR', avatar);
            commit('SET_DEVELOPERUID', developer_uid);
            commit('SET_GROUPID', group_id);
            commit('SET_USERINFO', data);
            commit('SET_EMAIL', email);
            localStorage.setItem((0, _utils.getStorageKey)('userInfo'), JSON.stringify(data)); // 暂存登录信息，防止页面刷新后store数据丢失

            resolve(data);
          }).catch(function (error) {
            reject(error);
          });
        });
      } else {
        LAYA_UNIFY_SDK && LAYA_UNIFY_SDK.init({
          company: 'huo5game',
          appId: '10001',
          loginChannel: ['passport'],
          payChannel: [],
          loginClose: false,
          loginByWeChat: true,
          gaeIframe: ''
        }, function () {
          console.log('init ok');
          commit('SET_IS_SDK_INIT', true); // 初始化成功

          LAYA_UNIFY_SDK && LAYA_UNIFY_SDK.login({
            'loginUrl': ''
          }, function (data) {
            console.log(data, '登录返回值');
            localStorage.setItem((0, _utils.getStorageKey)('loginSDK'), JSON.stringify(data));
            userInfo.code = data.token;
            (0, _common.login)(userInfo).then(function (response) {
              var data = response.data.data;

              if (!data) {
                reject('验证失败，请重新登录。');
              }

              var nickname = data.nickname,
                  avatar = data.avatar,
                  developer_uid = data.developer_uid,
                  group_id = data.group_id,
                  token = data.token,
                  email = data.email;
              commit('SET_TOKEN', token);
              (0, _auth.setToken)(token);
              commit('SET_NAME', nickname);
              commit('SET_AVATAR', avatar);
              commit('SET_DEVELOPERUID', developer_uid);
              commit('SET_GROUPID', group_id);
              commit('SET_USERINFO', data);
              commit('SET_EMAIL', email);
              localStorage.setItem((0, _utils.getStorageKey)('userInfo'), JSON.stringify(data)); // 暂存登录信息，防止页面刷新后store数据丢失

              resolve(data);
            }).catch(function (error) {
              reject(error);
            });
          });
        });
      }
    });
  },
  // get user info
  getInfo: function getInfo(_ref2) {
    var _arguments = arguments;
    return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var commit, state, refreshObj, userRes, userInfo, vipRes, vipInfo;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref2.commit, state = _ref2.state;
              refreshObj = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {
                refreshUserInfo: false,
                refreshVip: false
              };

              if (!(!state.userInfo || refreshObj.refreshUserInfo)) {
                _context.next = 15;
                break;
              }

              _context.next = 5;
              return (0, _common.getUserInfo)();

            case 5:
              userRes = _context.sent;
              userInfo = userRes.data.data;
              console.log("userInfo", userInfo);
              commit('SET_USERINFO', userInfo);
              commit('SET_NAME', userInfo.nickname);
              commit('SET_AVATAR', userInfo.avatar);
              commit('SET_DEVELOPERUID', userInfo.developer_uid);
              commit('SET_GROUPID', userInfo.group_id);
              commit('SET_EMAIL', userInfo.email);
              localStorage.setItem((0, _utils.getStorageKey)('userInfo'), JSON.stringify(userInfo)); // 暂存登录信息，防止页面刷新后store数据丢失

            case 15:
              if (!(!state.getVipStatus || refreshObj.refreshVip)) {
                _context.next = 25;
                break;
              }

              _context.next = 18;
              return (0, _user.getVipInfo)();

            case 18:
              vipRes = _context.sent;
              vipInfo = vipRes.data.data;
              console.log("vipInfo", vipInfo);
              commit('SET_VIP_LEVEL', vipInfo.vip_level);
              commit('SET_IS_VIP', vipInfo.is_vip);
              commit('SET_PERFORMANCE_COUNT', vipInfo.analysis_times);
              commit('SET_VIP_STATUS', true);

            case 25:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  // user logout
  logout: function logout(_ref3) {
    var commit = _ref3.commit,
        state = _ref3.state;
    return new Promise(function (resolve, reject) {
      clear({
        commit: commit
      }); // commit('SET_TOKEN', '')
      // commit('SET_ROLES', [])

      (0, _auth.removeToken)();
      LAYA_UNIFY_SDK && LAYA_UNIFY_SDK.logout(function () {
        var prefix = (0, _utils.getStorageKeyPrefix)();

        for (var key in localStorage) {
          if (key.startsWith(prefix)) {
            localStorage.removeItem(key);
          }
        }

        resolve();
      });
    });
  },
  // remove token
  resetToken: function resetToken(_ref4) {
    var commit = _ref4.commit;
    return new Promise(function (resolve) {
      clear({
        commit: commit
      });
      (0, _auth.removeToken)();
      localStorage.setItem((0, _utils.getStorageKey)('loginSDK'), '');
      localStorage.setItem((0, _utils.getStorageKey)('userInfo'), '');
      var prefix = (0, _utils.getStorageKeyPrefix)();

      for (var key in localStorage) {
        if (key.startsWith(prefix)) {
          localStorage.removeItem(key);
        }
      }

      resolve();
    });
  },
  updateLoadMenus: function updateLoadMenus(_ref5) {
    var commit = _ref5.commit;
    return new Promise(function (resolve, reject) {
      commit('SET_LOAD_MENUS', false);
    });
  }
};

function clear(_ref6) {
  var commit = _ref6.commit;
  commit('SET_TOKEN', '');
  commit('SET_NAME', '');
  commit('SET_AVATAR', '');
  commit('SET_DEVELOPERUID', '');
  commit('SET_GROUPID', '');
  commit('SET_ROLES', []);
  commit('SET_USERINFO', null);
  commit('SET_VIP_STATUS', false);
  commit('SET_VIP_LEVEL', 0);
  commit('SET_IS_VIP', false);
  commit('SET_PERFORMANCE_COUNT', 0);
  commit('SET_EMAIL', '');
  commit('SET_LOAD_MENUS', false);
}

var setUserInfo = function setUserInfo(res, commit) {
  // 如果没有任何权限，则赋予一个默认的权限，避免请求死循环
  if (res.roles.length === 0) {
    commit('SET_ROLES', ['ROLE_SYSTEM_DEFAULT']);
  } else {
    commit('SET_ROLES', res.roles);
  }

  commit('SET_USER', res.user);
};

exports.setUserInfo = setUserInfo;
var _default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};
exports.default = _default;